import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import { ConfigProvider } from 'antd';
import App from './App';
import { MuiThemeConfig } from './constants';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={MuiThemeConfig}>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#645AFF',
              colorBgContainerDisabled: '#C8C5FF',
              colorTextDisabled: '#fff',
              controlHeight: 36,
              borderRadius: 4,
            },
          }}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </ConfigProvider>

      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
